var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPrintIconDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.045,
    height: 20,
    viewBox: "0 0 18.045 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "receipt_FILL1_wght400_GRAD0_opsz48",
    d: "M6,24.05v-20l1.5,1.5,1.5-1.5,1.5,1.5,1.5-1.5,1.5,1.5,1.5-1.5,1.5,1.5,1.5-1.5,1.5,1.5,1.5-1.5,1.5,1.5,1.5-1.5v20l-1.5-1.5-1.5,1.5-1.5-1.5-1.5,1.5-1.5-1.5-1.5,1.5-1.5-1.5-1.5,1.5-1.5-1.5-1.5,1.5-1.5-1.5Zm2.932-5.388H21.213v-1.5H8.932Zm0-3.86H21.213V13.3H8.932Zm0-3.885H21.213v-1.5H8.932Z",
    transform: "translate(-6 -4.05)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrintIconDark);
export default __webpack_public_path__ + "static/media/print-icon-dark.83660a0c215c0537a56625f3df2ed52a.svg";
export { ForwardRef as ReactComponent };